export const regionStateTypes = {
  SET_REGIONS_BY_COUNTRY: 'SET_REGIONS_BY_COUNTRY',
  RESET_REGION_STATE: 'RESET_REGION_STATE'
};
